import { render, staticRenderFns } from "./Carrousel.vue?vue&type=template&id=7fd8b243"
import script from "./Carrousel.vue?vue&type=script&lang=js"
export * from "./Carrousel.vue?vue&type=script&lang=js"
import style0 from "./Carrousel.vue?vue&type=style&index=0&id=7fd8b243&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports